import { getCurrentBackendUrl } from '../../constants';

type SendRequest = (
  path: string,
  options?: RequestInit,
  needToken?: boolean,
  isFormData?: boolean,
  shouldRedirectToLogin?: boolean,
  extraHeaders?: Record<string, string>

) => Promise<Response>;

export const sendRequest:SendRequest = async (
  path,
  options = {},
  needToken = true,
  isFormData = false,
  shouldRedirectToLogin = true,
  extraHeaders = {}
) => {
  const token = localStorage.getItem('bearer');
  if (needToken && token) {
    const currentBackend = localStorage.getItem('selectedBackend');
    const lastUsedBackend = localStorage.getItem('lastUsedBackend');

    if (currentBackend !== lastUsedBackend) {
      localStorage.removeItem('bearer');
      window.location.href = '/login';
      return new Response(null, { status: 401 });
    }
  }

  const config = {
    ...options,
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
      ...extraHeaders,
    },
  };

  if (needToken) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  if (isFormData) {
    delete config.headers['Content-Type'];
  }
  const response = await fetch(`${getCurrentBackendUrl()}${path}`, config);

  if (response.status === 401 && shouldRedirectToLogin) {
    localStorage.removeItem('bearer')
    localStorage.removeItem('lastUsedBackend');
    console.error('Token expired. Redirecting to login page...');
    window.location.href = '/login';
  }

  return response;
};
